import { useMemo, useState } from "react";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { ISO, countryName, sortedCountries } from "./countries";

// Multi-select of ISO countries with Italian names. allLabel: when set, an empty selection means «all countries».
export default function CountryPicker({ value, onChange, options = ISO, allLabel, testid }) {
  const [q, setQ] = useState("");
  const list = useMemo(() => sortedCountries(options), [options]);
  const shown = list.filter((c) => !q || countryName(c).toLowerCase().includes(q.toLowerCase()) || c.toLowerCase() === q.toLowerCase())
    .sort((a, b) => Number(value.includes(b)) - Number(value.includes(a)));  // selected first
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  const label = !value.length ? (allLabel || "Nessun paese") : value.length <= 3 ? sortedCountries(value).map(countryName).join(", ") : `${value.length} paesi`;
  return (
    <Popover>
      <PopoverTrigger asChild><Button type="button" variant="outline" size="sm" className="h-9 w-full justify-start truncate text-xs font-normal" data-testid={testid}>{label}</Button></PopoverTrigger>
      <PopoverContent className="w-72 p-2" align="start">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca paese…" className="mb-2 h-8 text-xs" data-testid={`${testid}-search`} />
        <div className="mb-2 flex gap-2 text-[11px]">
          <button type="button" className="text-slate-600 underline" onClick={() => onChange([])} data-testid={`${testid}-clear`}>{allLabel ? allLabel : "Nessuno"}</button>
          {!allLabel && <button type="button" className="text-slate-600 underline" onClick={() => onChange([...options])} data-testid={`${testid}-all`}>Tutto il mondo</button>}
          {q && <button type="button" className="text-slate-600 underline" onClick={() => onChange([...new Set([...value, ...shown])])}>Seleziona i risultati</button>}
        </div>
        <div className="max-h-64 space-y-0.5 overflow-y-auto">{shown.map((c) => (
          <label key={c} className="flex cursor-pointer items-center gap-2 rounded px-1 py-1 text-xs hover:bg-slate-50" data-testid={`${testid}-opt-${c}`}>
            <input type="checkbox" checked={value.includes(c)} onChange={() => toggle(c)} />{countryName(c)} <span className="text-slate-400">{c}</span></label>))}</div>
      </PopoverContent>
    </Popover>
  );
}
